<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog width="1000px" :value="showDialog" persistent scrollable>
    <v-card>
      <v-toolbar class="primary" dark text>
        <div class="text-h6">{{label}} Proyecto</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validForm" ref="formProject" lazy-validation>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Nombre"
                              :rules="[rules.required]"
                              v-model="project.name">
                </v-text-field>
                <v-textarea
                  v-model="project.description"
                  auto-grow
                  label="Descripción"
                  rows="1"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="cancel">Cancelar</v-btn>
        <v-btn color="primary" @click="submit" :loading="submitting">Guardar proyecto</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/libs/rules'
export default {
  data () {
    return {
      validForm: true,
      rules: rules
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    submit () {
      if (!this.$refs.formProject.validate()) return
      this.$emit('submit', this.project)
    }
  },
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      },
      required: true
    },
    submitting: {
      type: Boolean,
      default: false,
      required: false
    },
    showDialog: {
      type: Boolean,
      default: false,
      required: true
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
